import { ButtonProps } from 'lib/components/Button/Button'
import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

import { IconListItem } from '@/components/IconList'

export interface AffiliatePageContent {
  hero: NarrativeHeroProps
  fifties: FiftyFiftyProps[]
  iconListHeader: string
  iconList: IconListItem[]
  leadFormProps: {
    header: string
    subHead: React.ReactNode
  }
  ctaHeader: string
  ctaBody: string
  ctaButtonLink: ButtonProps
  ctaButtonText: string
}

const BACKGROUND_IMAGE = '/images/shipsticks/hero-background-6.jpg'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'Join our affiliate program.',
  subHeader: `
    Earn money and make golf travel easy for your
    followers with the most trusted name in golf club shipping.
  `,
  button: {
    children: 'Become an affiliate',
    link: {
      href: '#lead-form',
    },
    variant: 'secondary',
  },
}

const fifties: FiftyFiftyProps[] = [
  {
    image: {
      src: '/images/shipsticks/affiliate-1.jpg',
    },
    backgroundColor: 'white',
    header: 'Why us?',
    layout: 'image-right',
    button: {
      text: 'Become an Affiliate',
      link: {
        href: '#lead-form',
      },
    },
    body: (
      <>
        ShipSticks makes golf travel a breeze by shipping golf clubs and luggage right to the resort
        or course and back again. The official shipping partner of the PGA of America with more than
        38,000 5-star reviews, ShipSticks is a service you can recommend with confidence.
      </>
    ),
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipsticks/affiliate-2.jpg',
    },
    backgroundColor: 'white',
    header: 'What’s in it for you?',
    layout: 'image-left',
    body: (
      <>
        In exchange for sharing the benefits of using ShipSticks, you&apos;ll receive financial
        rewards as well as genuine appreciation from followers who use the service.
      </>
    ),
    showEyebrow: false,
  },
  {
    image: {
      src: '/images/shipsticks/affiliate-3.jpg',
    },
    backgroundColor: 'white',
    header: 'How to join.',
    layout: 'image-right',
    button: {
      text: 'Become an Affiliate',
      link: {
        href: '#lead-form',
      },
    },
    body: (
      <>
        Joining is FREE. Just fill out the form linked below, and we&apos;ll help you find the
        partnership that makes the most sense (and money) for you.
      </>
    ),
    showEyebrow: false,
  },
]

const iconListHeader: string = 'Things to brag about'

const iconList: IconListItem[] = [
  {
    icon: 'check-circle-filled',
    header: 'Trusted by golfers worldwide',
    body: (
      <>
        With more than 500,000 bags shipped annually, ShipSticks is the most trusted name in golf
        travel.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'Premium experience',
    body: (
      <>
        Real-time tracking, free insurance, and customer support 7 days a week makes for a much
        better experience than trusting your clubs with the airlines.
      </>
    ),
  },
  {
    icon: 'check-circle-filled',
    header: 'In good company',
    body: (
      <>
        We partner with more than 3,500 golf destinations around the world, from Bandon Dunes to
        Pebble Beach. They trust us to deliver exceptional service and so can your followers.
      </>
    ),
  },
]

const leadFormProps = {
  header: 'Let’s talk.',
  subHead: (
    <>
      Becoming a ShipSticks affiliate is simple, fast, and free. Want in? Fill out the form to get
      started - we’ll be in touch with next steps.
    </>
  ),
}

const ctaHeader: string = 'Are you representing a golf course, resort or travel service?'
const ctaBody: string = 'If so, check out our partner page.'
const ctaButtonLink: ButtonProps = {
  link: {
    href: '/partnership-benefits',
    target: '_self',
  },
  variant: 'secondary',
}
const ctaButtonText: string = 'Learn More'

const content: AffiliatePageContent = {
  hero,
  fifties,
  iconListHeader,
  iconList,
  leadFormProps,
  ctaHeader,
  ctaBody,
  ctaButtonLink,
  ctaButtonText,
}

export default content
